import { applyWorkflowFilter as applyWorkflowFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';

export type Props = ApiMethodBase & {
    matching_variants?: any,
    workflow?: string
}

export async function  applyWorkflowFilter ({ matching_variants,workflow,eventEmitter}: Props) {
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    openProgressModal({status: 'Applying Workflow Filter'})
    await sleep(200) // needed to display Progress
    await apiProvider.resetFilters({regenerateArray: true})
    await applyWorkflowFilterDiagram({matching_variants: matching_variants, workflow: workflow},'',false);
    closeProgressModal()
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()    
    eventEmitter.emit(Event.updateGaugeMetrics);
};

